export default __webpack_public_path__ + "static/media/Addition_05.050ff2cb.png";